import PropTypes from 'prop-types';
import {Form, Input, Label} from 'semantic-ui-react';

DollarInputFormField.propTypes = {
  className: PropTypes.string.isRequired,
  error: PropTypes.string,
  inputValue: PropTypes.number,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function DollarInputFormField({className, error, inputValue, placeholder, onChange}) {
  return (
    <Form.Field width={5} className={className} error={!!error}>
      <Input value={inputValue || ''} labelPosition="left" placeholder={placeholder} onChange={onChange}>
        <Label>$</Label>
        <input/>
      </Input>
      {!!error ? <Label color="red" pointing>{error}</Label> : null}
    </Form.Field>
  );
}
